export default "__VITE_ASSET__daaa279a__"